import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance14tgug8r8maei as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
  ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException,
  NoDataException34qvcinicy2ih as NoDataException,
} from '../exception/Exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation, requestUuid, data, errors, extensions, exception) {
        return new.target.new_com_apollographql_apollo_api_ApolloResponse_Builder_bjnxiv_k$(operation, requestUuid, data, errors, extensions, exception);
      }
      static new_com_apollographql_apollo_api_ApolloResponse_Builder_bjnxiv_k$(operation, requestUuid, data, errors, extensions, exception) {
        var $this = createThis(this);
        $this.operation_1 = operation;
        $this.requestUuid_1 = requestUuid;
        $this.data_1 = data;
        $this.errors_1 = errors;
        $this.extensions_1 = extensions;
        $this.exception_1 = exception;
        $this.executionContext_1 = Companion_getInstance().Empty_1;
        $this.isLast_1 = false;
        return $this;
      }
      static new_com_apollographql_apollo_api_ApolloResponse_Builder_h8chhh_k$(operation, requestUuid) {
        return this.new_com_apollographql_apollo_api_ApolloResponse_Builder_bjnxiv_k$(operation, requestUuid, null, null, null, null);
      }
      addExecutionContext_c49mf3_k$(executionContext) {
        // Inline function 'kotlin.apply' call
        this.executionContext_1 = this.executionContext_1.plus_kymzvj_k$(executionContext);
        return this;
      }
      data_25r92p_k$(data) {
        // Inline function 'kotlin.apply' call
        this.data_1 = data;
        return this;
      }
      errors_tmpwze_k$(errors) {
        // Inline function 'kotlin.apply' call
        this.errors_1 = errors;
        return this;
      }
      exception_5qwc7n_k$(exception) {
        // Inline function 'kotlin.apply' call
        this.exception_1 = exception;
        return this;
      }
      extensions_sh2glh_k$(extensions) {
        // Inline function 'kotlin.apply' call
        this.extensions_1 = extensions;
        return this;
      }
      requestUuid_f5bk3d_k$(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.requestUuid_1 = requestUuid;
        return this;
      }
      isLast_feje11_k$(isLast) {
        // Inline function 'kotlin.apply' call
        this.isLast_1 = isLast;
        return this;
      }
      build_1k0s4u_k$() {
        var tmp1_operation = this.operation_1;
        var tmp2_requestUuid = this.requestUuid_1;
        var tmp3_data = this.data_1;
        var tmp4_executionContext = this.executionContext_1;
        var tmp0_elvis_lhs = this.extensions_1;
        var tmp5_extensions = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
        var tmp6_errors = this.errors_1;
        var tmp7_exception = this.exception_1;
        var tmp8_isLast = this.isLast_1;
        return new (ApolloResponse())(tmp2_requestUuid, tmp1_operation, tmp3_data, tmp6_errors, tmp7_exception, tmp5_extensions, tmp4_executionContext, tmp8_isLast);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloResponseClass;
function ApolloResponse() {
  if (ApolloResponseClass === VOID) {
    class $ {
      constructor(requestUuid, operation, data, errors, exception, extensions, executionContext, isLast) {
        this.requestUuid_1 = requestUuid;
        this.operation_1 = operation;
        this.data_1 = data;
        this.errors_1 = errors;
        this.exception_1 = exception;
        this.extensions_1 = extensions;
        this.executionContext_1 = executionContext;
        this.isLast_1 = isLast;
      }
      get_dataAssertNoErrors_kaff3v_k$() {
        var tmp;
        if (this.hasErrors_b5t4kb_k$()) {
          throw ApolloGraphQLException().new_com_apollographql_apollo_exception_ApolloGraphQLException_ytcmdd_k$(first(ensureNotNull(this.errors_1)));
        } else if (!(this.exception_1 == null)) {
          throw DefaultApolloException().new_com_apollographql_apollo_exception_DefaultApolloException_6xe6ia_k$('An exception happened', this.exception_1);
        } else {
          tmp = this.dataOrThrow_qbtbqx_k$();
        }
        return tmp;
      }
      dataOrThrow_qbtbqx_k$() {
        var tmp0_elvis_lhs = this.data_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw NoDataException().new_com_apollographql_apollo_exception_NoDataException_waozn4_k$(this.exception_1);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      hasErrors_b5t4kb_k$() {
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = this.errors_1;
        return !(this_0 == null || this_0.isEmpty_y1axqb_k$());
      }
      newBuilder_dnl2aj_k$() {
        return Builder().new_com_apollographql_apollo_api_ApolloResponse_Builder_bjnxiv_k$(this.operation_1, this.requestUuid_1, this.data_1, this.errors_1, this.extensions_1, this.exception_1).addExecutionContext_c49mf3_k$(this.executionContext_1).isLast_feje11_k$(this.isLast_1);
      }
      toString() {
        var tmp = 'operationName=' + this.operation_1.operationName() + ', ';
        var tmp_0 = 'data=' + (this.data_1 == null ? 'null' : this.operation_1.operationName() + '.Data') + ', ';
        var tmp0_safe_receiver = this.errors_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_size_woubt6_k$();
        var tmp_1 = 'errors=' + toString(tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs) + ', ';
        var tmp_2;
        if (this.exception_1 == null) {
          tmp_2 = 'null';
        } else {
          var tmp2_elvis_lhs = getKClassFromExpression(this.exception_1).get_simpleName_r6f8py_k$();
          tmp_2 = tmp2_elvis_lhs == null ? 'true' : tmp2_elvis_lhs;
        }
        return 'ApolloResponse(' + tmp + tmp_0 + tmp_1 + ('exception=' + tmp_2) + ')';
      }
    }
    initMetadataForClass($, 'ApolloResponse');
    ApolloResponseClass = $;
  }
  return ApolloResponseClass;
}
//region block: exports
export {
  Builder as Builder16nv925388a0q,
};
//endregion

//# sourceMappingURL=ApolloResponse.mjs.map
